<template>
  <div id="page">
    <div id="outer">
      <div id="title-div">
        <div id="allSpan-div">
          <div id="span-div1">
            <span id="title-span">批次线查询</span>
          </div>
        </div>

        <div id="select-banner" style="margin-right: 120px;">
          <el-form
            :model="form"
            inline
            style="display: flex; align-items: center"
            label-width="80px">
            <el-form-item label="所属省份" style="display: flex;">
                  <el-select @change="chaPice()" v-model="form.province" placeholder="全部" size="small"  style="width:120px;">
                    <el-option v-for="item in cityData" :key="item.title" :label="item.title" :value="item.title">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="年份" style="display: flex;">
                  <el-select @change="chaPice()" v-model="form.year" placeholder="请选择" size="small"  style="width:120px;">
                    <el-option v-for="item in yearArr" :key="item" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
            <el-form-item style="display: flex">
              <el-button type="success" size="small" @click="chaPice()">
                查询
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>


      <div style="width:80%;height: 78%;overflow-y: auto;margin: 0 auto;" v-loading="loading" v-if="list.length>0">
          <h4 style="margin-bottom: 10px;">{{form.year}}年</h4>
         <div v-for="(item,i) in list" :key="i" style="padding: 10px 0;">
             <el-table :data="[1]" border style="width: 100%" :header-cell-style="{background:'#f5f5f5'}">
              <el-table-column label="组别" align="center">
                  {{ item.group_d }}
              </el-table-column>
              <el-table-column label="强基线" align="center">
                {{
                  item.strong_basi?item.strong_basi:'--'
                }}
              </el-table-column>
              <el-table-column label="本科线" align="center">
                {{
                  item.undergraduate_line
                }}
              </el-table-column>
              <el-table-column label="专科线" align="center">
                {{
                  item.specialist_line
                }}
              </el-table-column>
        </el-table>
         </div>
      </div>
      <div v-if="list.length==0">
        <el-empty></el-empty>
      </div>


    </div>
  </div>
</template>
<script>
import { chaPice,selectYear } from "@/api/gw/zonghe.js"
import cityJson from "@/utils/city.json";
export default{
  data(){
    return{
      cityData: cityJson,
      loading:false,
      form:{
					province:"河北",
					year:""//年份
				},
				list:[],
        yearArr:[],//年份列表
    }
  },
  mounted(){
    this.selectYear();
  },
  methods:{
    chaPice(){
        const examTypeRaw = localStorage.getItem('selectedExamType');
        const examType = ['1','2','3'].includes(String(examTypeRaw)) ? String(examTypeRaw) : '1';
        let form = { ...this.form, examType };
        // 如果没有选择年份，不查询
        if(!form.year){
          return
        }
				this.loading = true
        chaPice(form).then(res=>{
          this.list = res.data
        }).finally(()=>{
          this.loading = false
        })
    },
    selectYear(){
      selectYear({}).then(res=>{
        if(res.data){
          this.yearArr = res.data
          if(!this.form.year && res.data.length > 0){
            // 选择最近的一年（最大的年份）
            const maxYear = Math.max(...res.data.map(year => Number(year)))
            this.form.year = maxYear
            // 设置默认年份后自动查询
            this.chaPice()
          } else if(this.form.year){
            // 如果已经有年份值，直接查询
            this.chaPice()
          }
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../scss/index.scss';

::v-deep .el-table {
  overflow: visible !important;
}

::v-deep .el-table__header-wrapper {
  position: sticky !important;
  top: 0 !important; //这个值根据实际情况而定
  z-index: 10 !important;
}
</style>




// WEBPACK FOOTER //
// src/views/comprehensive/components/pici.vue